import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  WsFrameType_Text_getInstancen453b7508b2k as WsFrameType_Text_getInstance,
  WsProtocol2u70gp1eq7nu9 as WsProtocol,
} from './WsProtocol.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  mapOf1xd03cq9cnmy8 as mapOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { withTimeout1cf9pp7nybo8u as withTimeout } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toRequestParameters3ovu7e0943da8 as toRequestParameters,
  toMap14rbdrx2whbk6 as toMap,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/RequestParameters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b() {
  return constructCallableReference(function *($completion) {
    return null;
  }, 0);
}
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor(connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$Factory$_init_$slambda_1syt4b();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        this.c69_1 = connectionAcknowledgeTimeoutMs;
        this.d69_1 = connectionPayload;
        this.e69_1 = frameType;
      }
      h1() {
        return 'graphql-ws';
      }
      f69(webSocketConnection, listener, scope) {
        var tmp0_connectionPayload = this.d69_1;
        var tmp1_connectionAcknowledgeTimeoutMs = this.c69_1;
        var tmp2_frameType = this.e69_1;
        return new (SubscriptionWsProtocol())(webSocketConnection, listener, tmp1_connectionAcknowledgeTimeoutMs, tmp0_connectionPayload, tmp2_frameType);
      }
    }
    initMetadataForClass($, 'Factory', Factory);
    FactoryClass = $;
  }
  return FactoryClass;
}
function SubscriptionWsProtocol$_init_$slambda_7z3jff() {
  return constructCallableReference(function *($completion) {
    return null;
  }, 0);
}
function SubscriptionWsProtocol$connectionInit$slambda(this$0) {
  return constructCallableReference(function *($this$withTimeout, $completion) {
    var map = yield* this$0.i69($completion);
    var type = map.u4('type');
    var tmp;
    if (equals(type, 'connection_ack')) {
      return Unit_instance;
    } else if (equals(type, 'connection_error')) {
      throw ApolloNetworkException().d47('Connection error:\n' + toString_0(map));
    } else {
      println("unknown message while waiting for connection_ack: '" + toString(type));
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
var SubscriptionWsProtocolClass;
function SubscriptionWsProtocol() {
  if (SubscriptionWsProtocolClass === VOID) {
    class $ extends WsProtocol() {
      constructor(webSocketConnection, listener, connectionAcknowledgeTimeoutMs, connectionPayload, frameType) {
        connectionAcknowledgeTimeoutMs = connectionAcknowledgeTimeoutMs === VOID ? 10000n : connectionAcknowledgeTimeoutMs;
        var tmp;
        if (connectionPayload === VOID) {
          tmp = SubscriptionWsProtocol$_init_$slambda_7z3jff();
        } else {
          tmp = connectionPayload;
        }
        connectionPayload = tmp;
        frameType = frameType === VOID ? WsFrameType_Text_getInstance() : frameType;
        super(webSocketConnection, listener);
        this.l69_1 = connectionAcknowledgeTimeoutMs;
        this.m69_1 = connectionPayload;
        this.n69_1 = frameType;
      }
      *o69($completion) {
        var message = mutableMapOf([to('type', 'connection_init')]);
        var payload = yield* this.m69_1($completion);
        if (!(payload == null)) {
          message.x4('payload', payload);
        }
        this.p69(message, this.n69_1);
        yield* withTimeout(this.l69_1, SubscriptionWsProtocol$connectionInit$slambda(this), $completion);
        return Unit_instance;
      }
      q69(messageMap) {
        var tmp0_subject = messageMap.u4('type');
        if (equals(tmp0_subject, 'data')) {
          var tmp = messageMap.u4('id');
          var tmp_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
          var tmp_1 = messageMap.u4('payload');
          this.h69_1.u69(tmp_0, (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE());
        } else if (equals(tmp0_subject, 'error')) {
          var id = messageMap.u4('id');
          if (!(id == null) ? typeof id === 'string' : false) {
            var tmp_2 = messageMap.u4('payload');
            this.h69_1.t69(id, (tmp_2 == null ? true : isInterface(tmp_2, KtMap())) ? tmp_2 : THROW_CCE());
          } else {
            var tmp_3 = messageMap.u4('payload');
            this.h69_1.s69((tmp_3 == null ? true : isInterface(tmp_3, KtMap())) ? tmp_3 : THROW_CCE());
          }
        } else if (equals(tmp0_subject, 'complete')) {
          var tmp_4 = messageMap.u4('id');
          this.h69_1.r69((!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
        }
      }
      v69(request) {
        this.p69(mapOf([to('type', 'start'), to('id', request.t40_1.toString()), to('payload', toMap(toRequestParameters(request)))]), this.n69_1);
      }
      c68(request) {
        this.p69(mapOf([to('type', 'stop'), to('id', request.t40_1.toString())]), this.n69_1);
      }
    }
    initMetadataForClass($, 'SubscriptionWsProtocol', VOID, VOID, VOID, [0]);
    SubscriptionWsProtocolClass = $;
  }
  return SubscriptionWsProtocolClass;
}
//region block: exports
export {
  Factory as Factory2jyzsj2j7cj0z,
};
//endregion

//# sourceMappingURL=SubscriptionWsProtocol.mjs.map
